import {
  Box,
  Typography,
  Stack,
  Button,
  Divider,
  AppBar,
  Container,
  Toolbar,
  Icon,
  CssBaseline,
} from "@mui/material";
import pepIcon from "../../images/pepElaOutlined.png";
import users from "../../images/home/users.png";
import userTag from "../../images/home/user-tag.png";
import security from "../../images/home/security.png";
import programing from "../../images/home/programing.png";
import gov from "../../images/home/gov.png";
import revela from "../../images/home/revela.png";
import lais from "../../images/home/lais.png";
import group from "../../images/home/group.png";
import pepEla from "../../images/home/pepElaLogo.png";
import wave from "../../images/home/wave.png";
import waveLeft from "../../images/home/waveLeft.png";
import { useNavigate } from "react-router-dom";

import {
  PersonOutlineOutlined,
  MonitorHeartOutlined,
} from "@mui/icons-material";

const styles = {
  boxMedia: {
    backgroundColor: "#D3E3EB",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "8px",
    padding: "1rem",
  },
  boxContent: {
    border: "1px solid #1E729F",
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    maxWidth: "460px",
    gap: "25px",
    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.15)",
  },
};

const CustomStack = ({ imageSrc, title, description, ml = "0px" }) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      alignItems={{ xs: "start", sm: "center" }}
      gap={{ xs: "0px", sm: "40px" }}
      ml={ml}
      sx={{ transition: "margin-left 0.4s ease, flex-direction 0.3s ease" }}
    >
      <Stack
        bgcolor={{ xs: "#D3E3EB", sm: "#D3E3EB" }}
        alignItems={"center"}
        justifyContent="center"
        borderRadius={{ xs: "8px 8px 0px 0px", sm: "8px" }}
        padding={{ xs: "0.5rem 3rem", sm: "1rem" }}
        border={{ xs: "1px solid #1E729F;", sm: "none" }}
        borderBottom={{ xs: "none", sm: "none" }}
        zIndex={10}
        marginBottom={{ xs: "-1px", sm: "0px" }}
      >
        <Stack
          height={{ xs: "40px", sm: "80px" }}
          width={{ xs: "40px", sm: "80px" }}
        >
          <Icon sx={{ width: "100%", height: "100%" }}>
            <img width="100%" height="100%" src={imageSrc} alt="userTag" />
          </Icon>
        </Stack>
      </Stack>
      <Box sx={styles.boxContent}>
        <Typography
          fontFamily="Nunito"
          fontWeight={900}
          color="#265974"
          lineHeight="22px"
        >
          {title}
        </Typography>
        <Typography lineHeight="22px">{description}</Typography>
      </Box>
    </Stack>
  );
};

const ImageFooter = ({ imageSrc, imageAlt }) => {
  return (
    <Stack
      sx={{ transition: "height 0.3s ease" }}
      height={{ xs: "66px", sm: "46px", md: "56px", lg: "66px" }}
    >
      <Icon style={{ width: "auto", height: "100%" }}>
        <img src={imageSrc} alt={imageAlt} height="100%" />
      </Icon>
    </Stack>
  );
};

export default function Home(params) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflowX: "hidden",
        lineHeight: "22px",
      }}
    >
      <CssBaseline />

      <AppBar
        position="static"
        sx={{
          display: "flex",
          width: "100%",
          height: "80px",
          justifyContent: "center",
          zIndex: 10,
        }}
      >
        <Container
          maxWidth="100vw"
          sx={{
            backgroundColor: "#3E94C2",
            height: "80px",
            zIndex: 10,
            display: "flex",
          }}
        >
          <Toolbar>
            <Stack
              direction={"row"}
              width={"100%"}
              alignItems="center"
              height={{ xs: "40px", sm: "54px" }}
              sx={{ transition: "height 0.3s ease" }}
            >
              <Icon style={{ width: "auto", height: "100%" }}>
                <img
                  style={{ width: "auto", height: "100%" }}
                  src={pepIcon}
                  alt={"Icone Pep"}
                />
              </Icon>
            </Stack>
          </Toolbar>
        </Container>
      </AppBar>

      <Stack
        position="relative"
        width={"100%"}
        sx={{
          minHeight: "calc(100vh - 190px)",
        }}
      >
        <Stack
          position="absolute"
          sx={{
            backgroundSize: "cover",
            backgroundImage: `url(${waveLeft})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-20px -60px ",
            width: "750px",
            height: "430px",
          }}
        ></Stack>
        <Stack
          position="absolute"
          sx={{
            backgroundSize: "cover",
            backgroundImage: `url(${wave})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-11px 26px",
            right: "-78px",
            width: "1100.23px",
            bottom: "0px",
            height: "833px",
            transform: "rotate(351deg)",
          }}
        ></Stack>
        <Stack
          height={"100%"}
          maxWidth={"1350px"}
          width={"100%"}
          direction={{ xs: "column", sm: "column", md: "row" }}
          justifyContent="space-between"
          sx={{
            margin: "0 auto",
            minHeight: "calc(100vh - 190px)",
            padding: "0px 48px",
            paddingBottom: "60px",
            zIndex: 10,
          }}
        >
          <Stack alignItems={"center"} mr={{ sx: "0px", sm: "30px" }}>
            <Stack
              mt={{ xs: "100px", sm: "100px", md: "260px" }}
              height={"100%"}
              maxWidth={475}
              width={"100%"}
              gap="24px"
            >
              <Typography
                color={"#265974"}
                fontSize={"1.5rem"}
                fontWeight={900}
                lineHeight={"22px"}
                fontFamily={"Nunito"}
              >
                Bem-vindo ao PEP ELA
              </Typography>
              <Box>
                <Typography lineHeight={"22px"} fontFamily={"Noto Sans"}>
                  O Prontuário Eletrônico para Pacientes diagnosticados com
                  Esclerose Lateral Amiotrófica (ELA), o PEP-ELA, constitui uma
                  plataforma inovadora para registro eletrônico de dados em
                  saúde, especializada no processamento inteligente de dados
                  relacionados à evolução do paciente com ELA
                </Typography>
              </Box>
              <Divider sx={{ borderColor: "#3E86AB" }} />
              <Typography
                color={"#265974"}
                fontSize={"18px"}
                fontWeight={600}
                lineHeight={"22px"}
              >
                Selecione o tipo de acesso
              </Typography>
              <Stack direction={"row"} gap={"24px"}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#1e729f",
                    fontWeight: 600,
                  }}
                  onClick={() => {
                    navigate("/pacienteLogin");
                  }}
                  startIcon={
                    <PersonOutlineOutlined
                      style={{
                        width: "24px",
                        height: "24px",
                        marginTop: "-2px",
                      }}
                    />
                  }
                >
                  Paciente
                </Button>
                <Button
                  variant="contained"
                  sx={{ bgcolor: "#1e729f", fontWeight: 600 }}
                  onClick={() => {
                    navigate("/login");
                  }}
                  startIcon={
                    <MonitorHeartOutlined
                      style={{
                        width: "24px",
                        height: "24px",
                      }}
                    />
                  }
                >
                  Profissional
                </Button>
              </Stack>
            </Stack>
          </Stack>

          <Stack
            justifyContent={"center"}
            alignItems={{ sm: "center", md: "flex-start" }}
            paddingTop={"52px"}
            paddingBottom={"30px"}
            gap={"40px"}
          >
            <CustomStack
              imageSrc={userTag}
              title="Humanização"
              description="Melhoria da qualidade de vida do paciente com ELA com dados de
                  apoio à decisão que contribuem na construção de protocolos
                  humanizados centrados no cuidado do paciente."
            />
            <CustomStack
              imageSrc={security}
              title="Segurança de dados"
              description="Arquitetura integrada baseada em blockchain que proporciona
              maior segurança, privacidade e confidencialidade na gestão de
              dados do prontuário para ELA, aderente à Lei Geral de Proteção
              de Dados - LGPD."
              ml={{ sm: "50px", md: "30px", lg: "130px", xl: "130px" }}
            />
            <CustomStack
              imageSrc={users}
              title="Acompanhamento Multidisciplinar"
              description="Prontuário centrado na experiência dos profissionais da equipe
              multidisciplinar, com cruzamento inteligente dos indicadores
              relacionados à evolução do paciente com ELA."
            />

            <CustomStack
              imageSrc={programing}
              title="Interoperabilidade"
              description=" Troca de informações com outros Registros Eletrônicos em Saúde
              do Brasil, em conformidade com os padrões da Rede Nacional de
              Dados em Saúde - RNDS."
              ml={{ sm: "50px", md: "30px", lg: "130px", xl: "130px" }}
            />
          </Stack>
        </Stack>
      </Stack>

      <Stack
        height={{ xs: "430px", sm: "100px" }}
        position="relative"
        width="100%"
        bgcolor="#D3E3EB"
        zIndex={10}
      >
        <Stack
          direction={{ xs: "column", sm: "row", md: "row" }}
          height={{ xs: "430px", sm: "100px" }}
          justifyContent="space-evenly"
          alignItems="center"
        >
          <ImageFooter imageAlt={"Governo Federal"} imageSrc={gov} />
          <ImageFooter
            imageAlt={"Laboratório de Inovação Tecnológica em Saúde"}
            imageSrc={lais}
          />
          <ImageFooter imageAlt={"Projeto RevELA"} imageSrc={revela} />
          <ImageFooter imageAlt={"Prontuário Eletrônico"} imageSrc={pepEla} />
          <ImageFooter
            imageAlt={"Hospital universitário Onofre Lopes"}
            imageSrc={group}
          />
        </Stack>
      </Stack>
    </Box>
  );
}
